var map = {
	"./Huawei-pay.svg": 274,
	"./alipay-2.svg": 5207,
	"./amazon-pay.svg": 9889,
	"./amex.svg": 6285,
	"./applepay.svg": 4842,
	"./billpay.svg": 2971,
	"./cup.svg": 6844,
	"./dcc.svg": 5670,
	"./dinersclub.svg": 8555,
	"./expresspay.svg": 3286,
	"./geldkarte.svg": 8147,
	"./girocard.svg": 6219,
	"./giropay.svg": 189,
	"./google-pay.svg": 3600,
	"./jcb.svg": 6861,
	"./klarna.svg": 8747,
	"./maestro.svg": 7175,
	"./mastercard-debit.svg": 5134,
	"./mastercard.svg": 3892,
	"./olv.svg": 2685,
	"./paypal.svg": 1653,
	"./prepaid.svg": 5009,
	"./rea-gutscheinkarten.svg": 8682,
	"./rea-lastschrift.svg": 2952,
	"./samsung-pay.svg": 2941,
	"./sepa-lastschrift.svg": 6101,
	"./sofortueberweisung.svg": 5966,
	"./tax-free.svg": 3882,
	"./v-pay.svg": 3515,
	"./visa-debit.svg": 8986,
	"./visa.svg": 4431
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7698;